import MenuIcon from '@/shared/assets/menu_icon.svg?react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/shared/components/ui/dropdown';
import RoundedIcon from '@/shared/components/ui/rounded-icon';

interface Props {
  items: React.ReactNode[];
}

export const RoundedDropdownMenu = ({ items }: Props) => {
  return (
    <RoundedIcon
      className="size-[39px]"
      icon={
        <DropdownMenu>
          <DropdownMenuTrigger>
            <MenuIcon className="size-6 text-white" />
          </DropdownMenuTrigger>
          <DropdownMenuContent
            side="top"
            align="end"
            sideOffset={12}
            alignOffset={-21.5}
          >
            {items}
          </DropdownMenuContent>
        </DropdownMenu>
      }
    />
  );
};
